// extracted by mini-css-extract-plugin
export default {"onwardJourney":"OnwardJourney_onwardJourney__p+Noe","multiLinkBlock":"OnwardJourney_multiLinkBlock__jSmmr"};